module.exports = __webpack_public_path__ + "img/3_AR-mb.d4302147.png";